export const GET_IMAGE_LIST_DROPDOWN = "GET_IMAGE_LIST_DROPDOWN"
export const STORE_IMAGE_LIST = "STORAGE_IMAGE_LIST"
export const STORE_CANVAS = "STORE_CANVAS"
